module.exports = __webpack_public_path__ + "images/gradients/gradient-flower.0142aa3ec31b01b27cad.svg";